(function($){
    $(document).ready(function(){
        if($('.wpcf7-form').length){
            $('input,textarea').on('focus', function() {
                console.log('focus');
                $(this).parent().addClass('move');
            })
            
            $('input,textarea').on('focusout', function() {
                console.log('focusout');
                if(!$(this).val()) $(this).parent().removeClass('move');
            })
        }
    });
})(jQuery);